import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { BuildingService, PointService, BuildingDoc, PathWaypointService } from '../../core/services';
import { Building } from '../../core/models';
import { FesBaseComponent } from '../../shared/components/fes-base.component';
import { AppState } from '../../core/app-state';
import { ShowRequest } from '../../core';
import { PointDoc } from '../../core/schema/point-schema';
import { AppTab } from '../../core/app-tab';
import { asyncScheduler, firstValueFrom } from 'rxjs';
import { PathKmlViewerModal } from '../../path/path-kml-viewer/path-kml-viewer-modal/path-kml-viewer-modal.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-building-view',
  templateUrl: './building-view.component.html',
  styleUrls: ['./building-view.component.css']
})
export class BuildingViewComponent extends FesBaseComponent implements OnInit, OnDestroy {

  @Input() buildingId: string

  @Input() set tabConfig( tabConfig : AppTab ) {
    tabConfig.setSelected = this.onTabSelected
  }

  public building : BuildingDoc
  public buildingFields : Building

  isResettingWeather = false;
  isLoading : boolean = false;
  errorMsg: string = "";

  constructor(appState: AppState, private buildingService : BuildingService, private pointService : PointService,
    public pathWaypointService: PathWaypointService,
    public modalService: BsModalService
   ) {
    super(appState)
  }

  ngOnInit(): void {
    this.buildingService.doWhenReady( () => this.loadBuilding() )
  }

  resetWeather() {
    this.isResettingWeather = true
    asyncScheduler.schedule( () => this.isResettingWeather = false, 0 )
  }

  bTabSelected = false;
  onTabSelected = ( bSelected : boolean ) => {
    console.log('building tab selected: ' + bSelected )
    this.bTabSelected = bSelected;
    if ( bSelected ) {
      this.buildingService.doWhenReady( () => this.loadBuilding() )
    }
  }

  ngOnDestroy(): void {
    this.destroy()
  }

  buildingPoints : PointDoc[]

  async loadBuilding() {
    console.log('loadBuilding()')
    this.errorMsg = ""
    this.buildingPoints = []

    if ( !this.buildingId ) {
      this.errorMsg = 'buildingId is not set'
      return
    }

    try {
      this.isLoading = true
      this.building = await this.buildingService.getById(this.buildingId)
      this.buildingFields = this.building?.toJSON();
      if ( !this.building ) {
        throw new Error("No building found for ID="+this.buildingId)
      } else {
        console.log('loading building points...')
        this.buildingPoints = await this.pointService.rxCollection.find({
          selector: {
            buildingId: this.buildingId
          }
        }).exec();
        console.log('buildingPoints count: ' + this.buildingPoints?.length)
      }
    } catch ( error ) {
      console.error(error);
      this.errorMsg = this.buildingService.extractErrorMsg(error)
    } finally {
      this.isLoading = false
    }
  }

  showPoint( pt : PointDoc ) {
    this.appState.showView.next( new ShowRequest('tab','point', pt._id) )
  }

  showingKmlViewer = false;
  async showKmlViewer() {
    this.showingKmlViewer = true;
    try {
      const buildingId = this.buildingId;
      const paths = await this.pathWaypointService.findBuilding3dPaths(buildingId);
      console.log('showKmlViewer()',{buildingId,paths});
      const modalRef = PathKmlViewerModal.show(this.modalService, {
        selectedPathIds: [],
        buildingId,
        paths
      });
      await firstValueFrom(modalRef.onHidden);
    } finally {
      this.showingKmlViewer = false;
    }
  }
}
